<div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0" style="font-size: 30px!important;font-weight: 500!important;"><span
                style="color:#3a87ad;font-size: 20px;padding-right: 10px;font-weight: 500;"> </span>
              Quotation</h4>
          </div>
        </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="invoice-container">
                    <h2 class="title">SALES ORDER/ PROFORMA INVOICE</h2>
                    <div class="row invoice-box mb-4" style="margin: 0px;">
                        <div class="col-md-6 p-0">
                            <div class="company-info">
                                <h6>{{quotationDetails.buyer.name}}</h6>
                                <p>{{quotationDetails.buyerShipmentData.dilivery}}<br>
                                    {{quotationDetails.buyerShipmentData.city}}<br>
                                   {{quotationDetails.buyerShipmentData.postalcode}}
                                </p>
                                <p class="m-0">{{quotationDetails.buyerShipmentData.country}}</p>
                              </div>
                        </div>
                        <div class="col-md-6 p-0" style="border-left: 1px solid #000;">
                            <div class="invoice-details">
                                <div>
                                  <p><strong>DATE:</strong> {{quotationDetails.poDetails.orderDate}}</p>
                                  <!-- <p><strong>SALES COORDINATOR:</strong>{{quotationDetails.salesRef.firstname}} {{quotationDetails.salesRef.lastname}}</p> -->
                                  <p><strong>SALES COORDINATOR:</strong> {{loggedUserName}}</p>
                                </div>
                                <div>
                                  <!-- <p><strong>CLIENT REF: {{quotationDetails.poDetails.jobName}}</strong></p> -->
                                  <p><strong>JOB: {{quotationDetails.poDetails.jobName}}</strong> </p>
                                </div>
                              </div>
                        </div>
                    </div>
               
                    <div class="row invoice-box mb-4" style="margin: 0px;">
                        <div class="col-md-6 p-0">
                            <div class="bill-to">
                                <h6>Bill To:</h6>
                                <div style="margin-left: 12px;">
                                    <p  class="m-0">{{quotationDetails.poDetails.billingAddressNavigation.dilivery}}</p>
                                    <!-- <p  class="m-0">37 WILSON STREET, HORSHAM, 3400 VIC, AUSTRALIA</p>
                                    <p  class="m-0">Shayne Bruer</p>
                                    <p  class="m-0">+613 5382 0018</p>
                                    <p  class="m-0">horsham</p> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 p-0" style="border-left: 1px solid #000;">
                            <div class="deliver-to">
                                <h6>Deliver To:</h6>
                                <div style="margin-left: 12px;">
                                    <p  class="m-0">{{quotationDetails.poDetails.localDeliveryAddressNavigation.dilivery}}</p>
                                    <!-- <p  class="m-0">37 WILSON STREET, HORSHAM, 3400 VIC, AUSTRALIA</p>
                                    <p  class="m-0">Shayne Bruer</p>
                                    <p  class="m-0">+613 5382 0018</p>
                                    <p  class="m-0">horsham</p> -->
                                </div>
                            </div>
                        </div>
                    </div>
         
                    <div class="row invoice-box mb-4" style="margin: 0px;">
                        <div class="col-md-6 p-0">
                            <div class="delivery-info">
                                <p><strong>DELIVERY:</strong> {{ quotationDetails.poDetails.estimatedDeliverDate}}</p>
                                <p class="m-0"><strong>MODE:</strong> {{ quotationDetails.poDetails.shipmentMode.mode}}</p>
                            </div>
                        </div>
                        <div class="col-md-6 p-0" style="border-left: 1px solid #000;">
                            <div class="delivery-info">
                                <p class="m-0"><strong>DELIVERY AUTHORIZATION:</strong> {{quotationDetails.localDeliveryAuthorize[quotationDetails.poDetails.localDeliveryAuthorization]}}</p>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let item of quotationDetails.poDetails.purchasingOrders;let i = index">
                          <div class="row mb-4" style="margin: 0px;">
                              <div class="col-md-12 p-0 p-0" style="margin: 0px;">
                                  <table class="order-table">
                                      <tbody>
                                        <tr>
                                          <td style="font-size: 12px;width: 18%;">ORDER SERIAL</td>
                                          <td style="font-size: 12px;width: 32%;">{{item.po}}</td>
                                          <td rowspan="7" style="width: 50%;text-align: center!important;;">
                                              <img src="{{baseImgUrl}}{{item.design.designImages[0].imgPath}}" alt="product image"style="width: auto; height: 200px;">
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">TYPE</td>
                                          <td style="font-size: 12px;">{{item.orderType.type}}</td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">ITEM NUMBER</td>
                                          <td style="font-size: 12px;">{{item.design.productNo}}</td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">LABELLING</td>
                                          <td style="font-size: 12px;">{{quotationDetails.poDetails.jobName}}</td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">NAMES AND NUMBERS</td>
                                          <td style="font-size: 12px;" *ngIf="item.nameSheetattached != 'N/A'">Yes </td>
                                          <td style="font-size: 12px;" *ngIf="item.nameSheetattached == 'N/A'">No </td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">PATTERN AND FABRIC</td>
                                          <td style="font-size: 12px;">
                                              <span *ngFor="let material of item.design.pattern.patternMaterials">
                                                  {{material.fabric.fabricCode}} - {{material.fabric.fabricName}}
                                              </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td style="font-size: 12px;width: 200px;">ORDER DETAIL NOTES</td>
                                          <td style="font-size: 12px;">{{item.specialinstuction}}</td>
                                        </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          <div class="row mb-4" style="margin: 0px;">
                              <div class="col-md-12 p-0" style="margin: 0px;">
                                  <table >
                                      <thead>
                                          <tr>
                                              <td [attr.colspan]="item.purchasingOrderSizes.length + 5" style="text-align: center!important">SIZES AND QUANTITY</td>
                                          </tr>
                                        <tr>
                                          <th *ngFor="let size of item.purchasingOrderSizes">
                                              {{size.size}}
                                          </th>
                                          <th>Total Qty</th>
                                          <th>Price</th>
                                          <th>Adj % +/-</th>
                                          <th>Final Price</th>
                                          <th>Value</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td *ngFor="let size of item.purchasingOrderSizes">
                                              {{size.qty}}
                                          </td>
                                          <td>{{getTotalQuantity(item.purchasingOrderSizes)}}</td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          <div *ngIf="tableColumnsList.length > 0">
                              <div>
                                  <div>
                                    <table
                                      class="table table-bordered text-center"
                                      *ngIf="tableColumnsList[i] && tableColumnsList[i].length > 0"
                                    >
                                      <thead class="table-light">
                                        <tr>
                                          <th rowspan="2">Size</th>
                                          <ng-container *ngFor="let col of tableColumnsList[i]">
                                            <th [attr.colspan]="col.fields.length">{{ col.part }}</th>
                                          </ng-container>
                                        </tr>
                                        <tr>
                                          <ng-container *ngFor="let col of tableColumnsList[i]">
                                            <th *ngFor="let field of col.fields">{{ field | titlecase }}</th>
                                          </ng-container>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let row of ordersizevaluesList[i]">
                                          <td>{{ row.ssize }}</td>
                                          <ng-container *ngFor="let col of tableColumnsList[i]">
                                            <td *ngFor="let field of col.fields">
                                              <ng-container [ngSwitch]="field">
                                                <span *ngSwitchCase="'name'">{{ row[col.part + '_name'] }}</span>
                                                <span *ngSwitchCase="'number'">
                                                  {{ row[col.part + '_number'] !== 0 ? row[col.part + '_number'] : '' }}
                                                </span>
                                              </ng-container>
                                            </td>
                                          </ng-container>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                  <div *ngIf="patternSpecialDetails && patternSpecialDetails.length > 0" style="margin-top: 20px;">
                                      <div class="table-responsive">
                                          <table class="table table-bordered mb-0">
                                              <thead style="font-size: 12px;">
                                                  <tr>
                                                      <th style="width: 20%;" id="th1">Description</th>
                                                      <th style="width: 20%;" id="th1">width </th>
                                                      <th style="width: 20%;" id="th1">Fabric Way</th>
                                                      <th style="width: 20%;" id="th1">Remark</th>
                                                      <th style="width: 20%;" id="th1">Color</th>
                                                  </tr>
                                              </thead>
                                              <tbody style="font-size: 12px;">
                                                  <tr *ngFor="let pattern of patternSpecialDetails;let i = index">
                                                      <td id ="td1"><span style="cursor: pointer;">{{ pattern.patternSpecialDetail.fabricNavigation.fabricCode}}</span> - {{ pattern.patternSpecialDetail.description }} - {{ pattern.patternSpecialDetail.fabricNavigation.fabricName }}</td>
                                                      <td id ="td1">{{ pattern.patternSpecialDetail.width }}</td>
                                                      <td id ="td1">{{ pattern.patternSpecialDetail.fabricWay }}</td>
                                                      <td id ="td1">{{ pattern.patternSpecialDetail.remark }}</td>
                                                      <td>
                                                          {{ pattern.fabricColor }}
                                                          <!-- <select class="form-control custom-select" [(ngModel)]="patternSpecialDetails[i].selectedColor" name="selectedColor2{{i}}">
                                                              <option *ngFor="let color of pattern.fabricColors" [value]="color.color">
                                                              <span>{{ color.color }}</span>
                                                              </option>
                                                          </select> -->
                                                      </td>
                                                  </tr>
                                              </tbody>
                                          </table>
                                      </div>
                                  </div>

                              </div>
                          </div>
                        <hr>
                    </div>
                  </div>
            </div>
        </div>
    </div>
</div>